import { render } from "./PublisherCheckbox.vue?vue&type=template&id=59f87d32&scoped=true"
import script from "./PublisherCheckbox.vue?vue&type=script&lang=js"
export * from "./PublisherCheckbox.vue?vue&type=script&lang=js"

import "./PublisherCheckbox.vue?vue&type=style&index=0&id=59f87d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f87d32"]])

export default __exports__